import {Component} from '@angular/core';
import {BaseSubscriptionComponent} from 'src/app/base/base.suscription.component';
import {HttpItineraryTemplatesService} from "../../services/http/http-itinerary.service";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import {lastValueFrom, map, takeUntil} from "rxjs";
import notify from "devextreme/ui/notify";
import {HttpDocumentsService} from "../../services/http/http-document.service";
import {ColumnEditCellTemplateData} from "devextreme/ui/data_grid";
import {ValueChangedEvent} from "devextreme/ui/file_uploader";
import {AttachedDocumentViewModel} from "../../models/view-models/itinerary-template";


@Component({
  selector: 'app-itinerary-templates',
  templateUrl: './itinerary-templates.component.html',
})
export class ItineraryTemplatesComponent extends BaseSubscriptionComponent {
  protected dataSource: DataSource;

  constructor(
    private httpItineraryTemplatesService: HttpItineraryTemplatesService,
    private httpDocumentsService: HttpDocumentsService
  ) {
    super();
    this.dataSource = new DataSource({
      store: new CustomStore({
        key: 'Id',
        load: () => lastValueFrom(this.httpItineraryTemplatesService.getItineraryTemplates().pipe(takeUntil(this.destroyed))),
        update: (id, itineraryTemplate) => {
          return lastValueFrom(this.httpItineraryTemplatesService.updateItineraryTemplate(id, itineraryTemplate).pipe(takeUntil(this.destroyed)));
        },
        insert: (itineraryTemplate) => {
          return lastValueFrom(this.httpItineraryTemplatesService.createItineraryTemplate(itineraryTemplate).pipe(map(_ => itineraryTemplate)).pipe(takeUntil(this.destroyed)))
        },
        remove: (id) => {
          return lastValueFrom(this.httpItineraryTemplatesService.deleteItineraryTemplate(id).pipe(takeUntil(this.destroyed)))
        }
      }),
    });
  }

  onRowUpdating(e: { oldData: never, newData: never }) {
    e.newData = Object.assign({}, e.oldData, e.newData);
  }

  public downloadDocument(id: number, fileName: string): void {
    this.httpDocumentsService
      .get(id)
      .pipe(takeUntil(this.destroyed))
      .subscribe({
        next: (blob: Blob) => {
          const downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = fileName;
          downloadLink.click();
        },
        error: (error) => {
          console.log(error);
          notify('Error trying download the file, please try again later', 'error', 10000);
        },
      });
  }


  documentChanged(event: ValueChangedEvent, info: ColumnEditCellTemplateData) {
    const file: File = event.value[0];
    const vm: UpdatedDocument = {
      FileName: file.name, Id: 0, _file: file
    }
    info.setValue(vm)
  }
}

export class UpdatedDocument extends AttachedDocumentViewModel {
  _file: File
}
